module.exports = __webpack_public_path__ + "static/media/verkoudheid.03a32cc4.svg";